import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useCurrencyListHook, useNavigation } from '../../../../Hooks';
import {
  requestTaxgroupsList,
  selectTaxgroupList,
  selectTaxgroupListError,
  selectTaxgroupListLoading,
} from '../../../../store/payments/taxgroups';

export const useItemCreationMoney = () => {
  const dispatch = useDispatch();
  const domain = useNavigation().getParams().domain;
  const { currencyList, isCurrencyListLoading, currencyListError } = useCurrencyListHook();

  const getTaxgroups = bindActionCreators(requestTaxgroupsList, dispatch);

  const taxgroupList = useSelector(selectTaxgroupList);
  const taxgroupListLoading = useSelector(selectTaxgroupListLoading);
  const taxgroupListError = useSelector(selectTaxgroupListError);

  useEffect(() => {
    if (!taxgroupList.length && !taxgroupListLoading && !taxgroupListError) {
      getTaxgroups(domain || '');
    }
  }, [domain]);

  return {
    currencyList,
    taxgroupList: taxgroupList.filter((taxgroup) => !taxgroup.archived),
    currencyListLoading: isCurrencyListLoading,
    taxgroupListLoading,
    error: currencyListError || taxgroupListError,
  };
};
